import React from 'react';
import LoadingCard from '../../../../../components/loadingCard';
import { useTranslation } from 'react-i18next';
import { Form, SelectHierarchy, Button, Icon, Label } from '@weezevent/nacre';
import useDateFormat from '../../../../../components/utils/useDateFormat';
import useAppContext from '../../../../../context/useAppContext';
import css from '../../styles.module.css';
import { useSegment } from '../../../../../components/tracking/trackingProvider';

export default function SessionsSelect({ sessions, onChangeSelectedSessions, onChangeSteps, form, loading }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    const [{ event }] = useAppContext();
    const [selected, setSelected] = React.useState();

    const session = React.useCallback(
        date => {
            const [dateWithDay, properTime] = useDateFormat({
                date,
                event,
                timeStyle: 'short'
            });
            return `${dateWithDay} - ${properTime}`;
        },
        [useDateFormat, event]
    );

    const options = React.useMemo(() => {
        // In case sessionsTree returns an unordered list, sessions are sorted by start_date
        // sessions?.sort((a, b) => a.start_date.localeCompare(b.start_date));
        return sessions?.map(option => ({ text: session(option.object.start_date), value: option.object.uuid, weez_date_id: option.weez_date_id }));
    }, [sessions]);

    const handleChange = React.useCallback(
        selected => {
            let selectedTmp = !Array.isArray(selected) ? [selected] : selected;
            setSelected(selectedTmp);
        },
        [setSelected]
    );

    const handleNext = React.useCallback(() => {
        onChangeSteps(2);
        track('ACTION > VALIDATE SESSIONS', { 'Page Title': 'ADD ATTENDEES' });
    }, [onChangeSteps]);

    // Keep in case session selection needs to be multiple

    // const handleLabelChange = React.useCallback(selected => {
    //     return selected.length
    //         ? `${selected.length} ${
    //               selected.length > 1
    //                   ? `${t('ticket.common.seances')} ${t('attendees.addAttendees.withSessions.plural')} `
    //                   : `${t('ticket.common.sessions')} ${t('attendees.addAttendees.withSessions.singular')} `
    //           }`
    //         : '';
    // }, []);

    const handleDelete = React.useCallback(
        selectedSession => {
            const buffer = [...selected];
            for (let i = 0; i < buffer.length; i++) {
                if (buffer[i] === selectedSession.value) {
                    buffer.splice(i, 1);
                }
            }
            setSelected(buffer);
        },
        [selected]
    );

    const handleDeleteAll = React.useCallback(() => {
        setSelected();
    }, [setSelected]);

    const filteredSessions = React.useMemo(() => {
        let list = [];
        if (selected?.length) {
            options.forEach(session => {
                selected.forEach(element => {
                    if (element === session.value) {
                        list.push(session);
                    }
                });
            });
        }
        onChangeSelectedSessions(list);
        return list;
    }, [selected]);

    const selectedList = React.useMemo(() => {
        if (selected?.length > 1) {
            return (
                <div className={css['rates-manager-container']}>
                    <div className={css['rates-manager-delete-all']} onClick={handleDeleteAll}>
                        <span>
                            <Icon name="trash" size="regular" />
                            {t('attendees.addAttendees.withSessions.delete')}
                        </span>
                    </div>

                    {form.sessions?.forEach(selectedSession => {
                        return (
                            <Label key={selectedSession.id} className={css['selected-inventories-labels']} nameIcon="delete">
                                <span>{selectedSession.text}</span>
                                <Icon name={'cross'} onClick={() => handleDelete(selectedSession)} />
                            </Label>
                        );
                    })}
                </div>
            );
        }
    }, [selected, form, filteredSessions]);

    if (loading) {
        return <LoadingCard loading />;
    }

    return (
        <>
            <Form.Field>
                <Form.Label label={t('ticket.common.seances')} />
                <SelectHierarchy
                    placeholder={t('ticket.common.action.select')}
                    placeholderSearch={t('ticket.common.action.search')}
                    depth={0}
                    height="maxi"
                    //onLabelSelected={handleLabelChange}
                    value={selected}
                    onChange={handleChange}
                    options={options}
                    multi={false}
                    //totalItems={options?.length}
                    //labelSelectAll={t('attendees.addAttendees.withSessions.sessions')}
                    //labelApply={t('ticket.common.action.select')}
                />
            </Form.Field>
            {selectedList}
            <Button className={css['progress-buttons']} primary disabled={!form.sessions?.length} label={t('ticket.common.action.continue')} onClick={handleNext} />
        </>
    );
}
